<!-- 运行监控页面 -->
<template>
  <div class='pagebg box box_v' id="page">
    <div class="title">{{title}}</div>
    <div class="content box box_f1">
      <div class="col-1 box box_v">
        <div class="box_f1 bgc-noselect" :class="{bgcSelect:isActive==0}"
             @mouseover="inCard(0)" @mouseout="outCard()">
          <chart-card title="社区生活服务" :font-size="22">
            <chart-one :index="index" :token="street.token"></chart-one>
          </chart-card>
        </div>
        <div class="box_f1 bgc-noselect" :class="{bgcSelect:isActive==1}"
             @mouseover="inCard(1)" @mouseout="outCard()">
          <chart-card title="社区办理" :font-size="22">
            <chart-two :index="index" :token="street.token"></chart-two>
          </chart-card>
        </div>
        <div class="box_f1 bgc-noselect" :class="{bgcSelect:(isActive==2)}"
             @mouseover="inCard(2)" @mouseout="outCard()">
          <chart-card title="公服企业" :font-size="22">
            <table-one :token="street.token"></table-one>
          </chart-card>
        </div>

        <!--<div class="box_f1 bgc-noselect" :class="{bgcSelect:(isActive==3)}"-->
             <!--@mouseover="inCard(3)" @mouseout="outCard()">-->
          <!--<chart-card title="社工/党员办理" :font-size="22">-->
            <!--<chart-three :index="index" :token="street.token"></chart-three>-->
          <!--</chart-card>-->
        <!--</div>-->
      </div>

      <div class="col-3 box box_v">
        <!--地图-->
        <div class="box_f1 mapcontainer" :id="'container'+index"></div>
        <!--今日概况-->
        <div class="countbox box">
          <count :token="street.token"></count>
        </div>
      </div>

      <div class="col-1  box box_v">
        <div class="box_f1 bgc-noselect" :class="{bgcSelect:(isActive==4)}"
             @mouseover="inCard(4)" @mouseout="outCard()">
          <chart-card title="社区活动次数统计" :font-size="22">
            <chart-four :index="index" :token="street.token"></chart-four>
          </chart-card>
        </div>
        <div class="box_f1 bgc-noselect" :class="{bgcSelect:(isActive==5)}"
             @mouseover="inCard(5)" @mouseout="outCard()">
          <chart-card title="参与情况统计" :big="true" :font-size="22">
            <chart-five :index="index" :token="street.token"></chart-five>
          </chart-card>
        </div>
        <div class="box_f1 bgc-noselect" :class="{bgcSelect:(isActive==6)}"
             @mouseover="inCard(6)" @mouseout="outCard()">
          <chart-card title="活跃社区" :font-size="22">
            <table-two :token="street.token"></table-two>
          </chart-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  var map,map1, map2, infoWindow, timer
  import chartCard from './components/chartcard';
  /**统计图们 */
  import chartOne from './components/chart1';
  import chartTwo from './components/chart2';
  import chartThree from './components/chart3';
  import chartFour from './components/chart4';
  import chartFive from './components/chart5';
  /**表格们 */
  import tableOne from './components/table1';
  import tableTwo from './components/table2';
  /**今日概况 */
  import count from './components/count';
  import {setInterval, clearInterval} from 'timers';

  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {chartCard, chartOne, chartTwo, chartThree, chartFour, chartFive, tableOne, tableTwo, count},
    provide: {
      isSmallWidth: document.body.offsetWidth < 1610 ? true : false
    },
    props: {
      index: null,
      street: null,
    },
    data() {
      //这里存放数据
      return {
        title: '',
        isActive: null,
        map:'',
        markerList:[],
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      /**鼠标悬浮,点击改变背景色 */
      inCard(val) {
        this.isActive = val
      },
      outCard() {
        this.isActive = null
      },
      /**获取街道范围 */
      getStreetPosition() {
        var url = this.urlobj.getStreetPosition
        this.$get(url, {}, {
          token: this.street.token
        }).then(res => {
          if (res.isSucceed) {
            if (res.rows[0]) {
              this.title = res.rows[0].streetName.split('街道')[0] + '街道基层治理平台运行概况'
              res.rows[0].coordinate && this.drawMap(res.rows[0].coordinate)
            } else {
              this.getAreaAndStreet()
            }
          }
        }).catch(e => {

        })
      },
      /**根据坐标绘制范围 */
      drawMap(data) {
        var that = this
        var id = 'container' + this.index
        this.map = new AMap.Map(id, {
          mapStyle: "amap://styles/0dd55e5d7d8ea7df349126652ba128bf",
          showLabel: false,
          zooms: [3, 18],
          resizeEnable: true, //是否监控地图容器尺寸变化
          zoom: 12,
          animateEnable: true,
        });
        let polygons = []
        var newdata = JSON.parse(data).map(item => {
          return new AMap.LngLat(item.lng, item.lat)
        })
        var bounds = []
        bounds[0] = newdata
        if (bounds) {
          for (var i = 0, l = bounds.length; i < l; i++) {
            console.log(bounds[i])
            var polygon = new AMap.Polygon({
              map: that.map,
              strokeWeight: 5,
              strokeColor: '#00eaff',
              fillColor: '#070e3d',
              fillOpacity: 0,
              path: bounds[i]
            });
            polygons.push(polygon);
          }
          that.map.add(polygons)
          that.map.setFitView(polygons);//地图自适应
          this.getActivity()
        }
      },
      /**获取行政区域 */
      getAreaAndStreet() {
        var url = this.urlobj.getAreaAndStreet
        this.$get(url, {}, {
          token: this.street.token
        }).then(res => {
          if (res.isSucceed) {
            this.title = res.rows[0].streetName.split('街道')[0] + '街道基层治理平台运行概况'
            this.initMap(res.rows[0].areaName)
          }
        }).catch(e => {

        })
      },
      initMap(areaName) {
        let that = this
        var id = 'container' + this.index
        // 初始化地图
        this.map = new AMap.Map(id, {
          mapStyle: "amap://styles/0dd55e5d7d8ea7df349126652ba128bf",
          showLabel: false,
          zooms: [3, 18],
          resizeEnable: true, //是否监控地图容器尺寸变化
          zoom: 12,
          animateEnable: true,
        });
        // AMap.plugin('AMap.DistrictSearch', function () {
        var districtSearch = new AMap.DistrictSearch({
          // 关键字对应的行政区级别，country表示国家
          subdistrict: 0,   //获取边界不需要返回下级行政区
          extensions: 'all',  //返回行政区边界坐标组等具体信息
          level: 'district'  //查询行政级别为 市
        })
        // 搜索所有省/直辖市信息
        districtSearch.search(areaName, function (status, result) {

          // 查询成功时，result即为对应的行政区信息
          if (status == 'complete') {
            // {
            //     O: 116.72552400000001
            //     P: 39.624071
            //     lat: 39.624071
            //     lng: 116.725524
            // }
            that.getData(result.districtList[0]);
          }
        })
        //})

      },
      getData(data, level) {
        var that = this
        let polygons = []
        var bounds = data.boundaries;
        if (bounds) {
          for (var i = 0, l = bounds.length; i < l; i++) {

            var polygon = new AMap.Polygon({
              map: that.map,
              strokeWeight: 1,
              strokeColor: '#008eff',
              fillColor: '#151c54',
              fillOpacity: 0.9,
              path: bounds[i]
            });
            polygons.push(polygon);
          }
          that.map.add(polygons)
          // that.map.setFitView(polygons);//地图自适应
          this.getActivity()
        }
      },
      getActivity () {
        var that = this
        var url = this.urlobj.getActivity;
        //加载中 不可以点击切换
        // this.tabClick = false
        this.$post(url, {
            pageNum: 1,
            pageSize:5,
            isSend: 1,
            recentDay: -1, // 代表全部
          },{
          token: this.street.token
        }).then(res => {
          if (!res.rows.length) return
          res.rows.forEach((item, index) => {
            // 处理经纬度
            var lng = parseFloat(JSON.parse(item.coordinate).x),lat = parseFloat(JSON.parse(item.coordinate).y)
            if (lng < lat ) {
              var a= lng
              lng = lat
              lat = a
            }
            if (index==0) that.map.setCenter([lng,lat])
            var icon = new AMap.Icon({
              size: new AMap.Size(50, 50), // 图标尺寸
              image: require('../../assets/images/qizi.png'),
              imageSize: new AMap.Size(50, 50) // 根据所设置的大小拉伸或压缩图片
            });
            var marker = new AMap.Marker({
              position: new AMap.LngLat(
                lng,
                lat
              ), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              icon: icon,
              label:{
                content: "<div class='event'>" + item.title + "</div>",
                offset: new AMap.Pixel(0, 0),
                direction: 'center'
              },
            });
            that.markerList.push(marker);
          })
          that.map.add(that.markerList);
        })
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      console.log(this.street)
      // this.getAreaAndStreet()
      this.getStreetPosition()
      //this.isActive = 0;
      //this.autoView()
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
      clearInterval(timer)
      //timer = null
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='less' scoped>
  //@import url(); 引入公共css类
  /deep/ .count-wrapper{
    width: 100%;
  }
  /deep/ .row{
    flex:1;
    font-size: 20px;
    height: 50px;
  }
  /deep/ .title{
    font-size: 18px;
  }
  /deep/ .tongji{
    font-size: 20px;
  }
  /deep/ .num-wrapper{
    margin-right: 15px;
  }
  /deep/ .cardbg{
    padding-top: 10px;
  }
  /deep/ .nodataBox{
    font-size: 18px;
  }
  /deep/ .tablebox{
    font-size: 18px;
  }
  .event {

  }
  /deep/ .amap-marker-label{
    border: 1px solid #6f90ed;
    background-color: #12153e;
    color:#03d2ff;
    padding: 10px 20px;
    font-size: 16px;
    transform: translate(-40%,-100%);
    max-width: 225px;
    white-space: normal;
    word-break: break-all;
    line-height: 1.5;
    width: max-content;
    word-wrap: break-word;
  }
  .pagebg {
    width: 100%;
    height: 100%;
    background-image: url('../../assets/images/monitor/bg.jpg');
    background-size: 100%;
  }

  .title {
    width: 100%;
    height: 60px;
    background-image: url('../../assets/images/monitor/titlebg.png');
    background-size: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 6px;
  }

  .content {
    margin: 20px;
  }

  .col-1 {
    /*width: 20%;*/
    flex:1
  }

  .col-1 > div {
    // margin-bottom: 30px;
    // background-image: url('../../assets/images/monitor/rect-s.png');
    // background-size: 100% 100%;
    margin-bottom: 30px;

  }

  @media screen and (max-width: 1600px) {
    .col-1 > div {
      margin-bottom: 10px;

    }
  }

  .col-1 > div:last-child {
    margin-bottom: 0
  }

  .col-3 {
    /*width: 60%;*/
    width: 50%;
    position: relative;
  }

  .bgc-noselect {
    // width: 100%;
    // height: 100%;
    background-image: linear-gradient(to bottom, rgba(71, 41, 133, .5), rgba(32, 141, 175, .2), rgba(255, 255, 255, 0));
  }

  .bgcSelect {
    background-image: none !important;
    background-color: #0c0e2f !important;
  }

  .box_f2 {
    flex: 2
  }

  .box_f3 {
    flex: 4
  }

  /*地图*/
  .mapcontainer {
    // height: 100%;
    //height: 90%;
    margin: 0 20px;
    background:#1f2764
  }

  /*今日概况*/
  .countbox {
    // position: absolute;
    // left: 0;
    // bottom: 0;
  }

  /*右上角时间*/
  .time {
    position: absolute;
    right: 15px;
    top: 0;
    color: #bdc0d3;
    font-size: 13px;

  }

  .shijian {
    color: #7078b7;
    margin-right: 8px;
    font-size: 18px;
    margin-top: -2px;
  }

  .infoBox {
    border: 1px solid #7192f1;
    border-radius: 4px;
    background: #12153e;
    color: #02d7ff;
    font-size: 18px;
    padding: 10px 20px;
  }
</style>
